import { Button, Table } from "reactstrap";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { confirm } from "components/Confirmation";
import { alert } from "components/Alert";

import contratoService from "services/ContratoService";

import ModalGrupo from "./ModalGrupo";
import Item from "./Item";
import ModalSelecaoGrupoItem from "./ModalSelecaoGrupoItem";
import ModalItem from "./ModalItem";
import ModalImportar from "./ModalImportar";import ModalHistoricoLogs from "components/ModalHistoricoLogs"
import './index.scss'
import { erroInesperado, totalizar } from "services/Utils";

const paiRoot = {
  id: null,
  descricao: 'Grupo Principal'
}

export default function Items({ idContrato, onChange, edit }) {
  const [itens, setItens] = useState([])
  const [configModalGrupo, setConfigModalGrupo] = useState()
  const [configModalSelecao, setConfigModalSelecao] = useState()
  const [configModalItem, setConfigModalItem] = useState()
  const [visibleModalImportar, setVisibleModalImportar] = useState()
  const [modalLog, setModalLog] = useState({ isOpen: false, tipo: null, idRegistro: null, titulo: '' })
  const [exibirInativos, setExibirInativos] = useState(false)

  const carregar = async () => {
    if (idContrato) {
      contratoService.getItems(idContrato, undefined, true).then(res => {
        if (res.success) {
          setItens(res.data)
        }
      })
    }
  }

  useEffect(() => {
    carregar()
  }, [idContrato])

  const handleCriarGrupo = () => {
    if (idContrato == 0) {
      alert({
        header: 'Importar',
        text: 'Você precisa primeiro salvar o contrato para criar grupos.',
        icon: 'bi-exclamation-triangle',
      })
      return
    }
    setConfigModalGrupo({
      pai: paiRoot,
      modo: 'create'
    })
  }

  const handleSalvarGrupo = async (idPai, modo, idGrupo, { codigo, descricao }) => {
    try {
      if (modo == 'create') {
        await contratoService.createGroup(idContrato, { idPai, codigo, descricao })
      } else {
        await contratoService.updateGroup(idContrato, idGrupo, { codigo, descricao })
      }
      carregar()
      setConfigModalGrupo()
    } catch (ex) {
      console.log(ex)
      erroInesperado()
    }
  }

  const handleSalvarItem = async (idGrupo, modo, { id, codigo, descricao, unidade, precoUnitario, quantidadeContratada }) => {
    if (modo == 'create') {
      await contratoService.createItem(idContrato, {
        idContratoGrupoItem: idGrupo,
        codigo,
        descricao,
        unidade,
        precoUnitario,
        quantidadeContratada
      })
    } else {
      await contratoService.updateItem(idContrato, id, {
        descricao,
        unidade,
        precoUnitario,
        quantidadeContratada
      })
    }
    onChange && onChange()
    carregar()
    setConfigModalItem()
  }

  const handleClick = (event, source) => {
    console.log({ event, source })

    const editItem = () => {
      setConfigModalItem({
        pai: {
          id: source.idPai,
          descricao: source.pai.codigo + ' - ' + source.pai.descricao
        },
        modo: 'edit',
        data: source
      })
    }

    const deleteItem = () => {
      confirm({
        header: 'Excluir item',
        text: `Tem certeza que deseja excluir o item "${source.codigo} - ${source.descricao}"?`,
        icon: 'bi-exclamation-triangle',
        onConfirm: async () => {
          try {
            const res = await contratoService.deleteItem(idContrato, source.id)
            if (res.success) {
              onChange && onChange()
              carregar()
              toast("Item excluído")
            } else {
              toast("Erro ao excluir o item")
            }
          } catch (ex) {
            toast("Erro ao excluir o item")
          }
        }
      })
    }

    const editGroup = () => {
      const pai = source.idPai ? {
        id: source.pai.id,
        descricao: source.pai.codigo + ' - ' + source.pai.descricao
      } : paiRoot

      setConfigModalGrupo({
        id: source.id,
        pai,
        modo: 'edit',
        data: source
      })
    }

    const create = () => {
      const pai = {
        id: source.id,
        descricao: source.codigo + ' - ' + source.descricao
      }

      setConfigModalSelecao({
        pai
      })
    }

    const deleteGroup = () => {
      if (source.filhos.length > 0) {
        alert({
          header: 'Exclusão',
          text: 'Não é possível excluir um grupo com subgrupos ou itens abaixo.',
          icon: 'bi-exclamation-triangle',
        })
      } else {
        confirm({
          header: 'Excluir grupo',
          text: `Tem certeza que deseja excluir o grupo "${source.codigo} - ${source.descricao}"?`,
          icon: 'bi-exclamation-triangle',
          onConfirm: async () => {
            try {
              const res = await contratoService.deleteGroup(idContrato, source.id)
              if (res.success) {
                carregar()
                toast("Grupo excluído")
              } else {
                toast(res?.data?.message || "Erro ao excluir o grupo")
              }
            } catch (ex) {
              toast(ex?.response?.data?.message || "Erro ao excluir o grupo")
            }
          }
        })
      }
    }

    switch (event) {
      case 'create':
        create()
        break
      case 'edit':
        editItem()
        break
      case 'delete':
        deleteItem()
        break
      case 'restore_item':
        confirm({
          header: 'Restaurar item',
          text: `Tem certeza que deseja restaurar o item "${source.codigo} - ${source.descricao}"?`,
          icon: 'bi-arrow-counterclockwise',
          onConfirm: async () => {
            try {
              await contratoService.restaurarItem(idContrato, source.id)
              onChange && onChange()
              carregar()
              toast('Item restaurado')
            } catch (ex) {
              toast('Erro ao restaurar o item')
            }
          }
        })
        break
      case 'edit_group':
        editGroup()
        break
      case 'delete_group':
        deleteGroup()
        break
      case 'restore_group':
        confirm({
          header: 'Restaurar grupo',
          text: `Tem certeza que deseja restaurar o grupo "${source.codigo} - ${source.descricao}"?`,
          icon: 'bi-arrow-counterclockwise',
          onConfirm: async () => {
            try {
              await contratoService.restaurarGrupoItem(idContrato, source.id)
              carregar()
              toast('Grupo restaurado')
            } catch (ex) {
              toast('Erro ao restaurar o grupo')
            }
          }
        })
        break
      case 'log':
        setModalLog({
          isOpen: true,
          tipo: (!!source.itens || !!source.filhos) ? 'grupo_item' : 'item',
          idRegistro: source.id,
          titulo: `LOG: ${source.codigo} - ${source.descricao}`
        })
        break
    }
  }

  const handleSelecao = (tipo, pai) => {
    if (tipo == 'grupo') {
      setConfigModalGrupo({ pai, modo: 'create' })
    } else if (tipo == 'item') {
      setConfigModalItem({ pai, modo: 'create' })
    }
    setConfigModalSelecao()
  }

  const handleImportar = () => {
    if (idContrato == 0) {
      alert({
        header: 'Importar',
        text: 'Você precisa primeiro salvar o contrato para importar itens.',
        icon: 'bi-exclamation-triangle',
      })
      return
    }
    setVisibleModalImportar(true)
  }

  const handleImportarUpdated = () => {
    carregar()
    onChange && onChange()
  }

  const contarInativos = (lista) => {
    let count = 0
    for (const el of lista) {
      if (el.ativo === false) count++
      if (el.itens) count += contarInativos(el.itens)
      if (el.filhos) count += contarInativos(el.filhos)
    }
    return count
  }

  const inativosCount = contarInativos(itens)
  const showExibirInativosControl = edit === true && inativosCount > 0

  useEffect(() => {
    if (!showExibirInativosControl && exibirInativos) {
      setExibirInativos(false)
    }
  }, [showExibirInativosControl, exibirInativos])

  return (
    <div className="contratos-items">
      {edit && (
        <div className="d-flex justify-content-end mb-2">
          <div className="text-right">
            <Button color="primary" onClick={() => handleImportar()}>Importar</Button>
            <Button color="primary" onClick={() => handleCriarGrupo()}>Criar grupo</Button>
          </div>
        </div>
      )}
      {showExibirInativosControl && (
        <div className="d-flex align-items-center justify-content-between mb-2">
          <div className="text-muted small mr-3">
            {exibirInativos
              ? `Exibindo ${inativosCount} item(ns) excluído(s)`
              : `Ocultando ${inativosCount} item(ns) excluído(s)`}
          </div>
          <div className="d-flex align-items-center mb-0 gap-5px">
            <div>Exibir excluídos</div>
            <label className="custom-toggle" style={{ marginBottom: 0 }}>
              <input
                type="checkbox"
                id="exibirInativosItens"
                checked={exibirInativos}
                onChange={e => setExibirInativos(e.target.checked)}
              />
              <span className="custom-toggle-slider rounded-circle" />
            </label>
          </div>
        </div>
      )}
      <Table className="align-items-center table-flush">
        <thead>
          <tr>
            <th>Item</th>
            <th>Descrição</th>
            <th>Unid</th>
            <th className="text-right">Valor Unit.</th>
            <th className="text-right">Quantidade</th>
            <th className="text-right">Valor Total</th>
            <th style={{ width: 120 }}></th>
          </tr>
        </thead>
        <tbody>
          {itens.map(el => <Item key={el.id} {...el} onClick={handleClick} edit={edit} exibirInativos={exibirInativos} />)}
        </tbody>
      </Table>

      <ModalGrupo
        config={configModalGrupo}
        onClosed={() => setConfigModalGrupo()}
        onSave={handleSalvarGrupo}
      />

      <ModalSelecaoGrupoItem
        idContrato={idContrato}
        config={configModalSelecao}
        onClosed={() => setConfigModalSelecao()}
        onSelect={handleSelecao}
      />

      <ModalItem
        idContrato={idContrato}
        config={configModalItem}
        onClosed={() => setConfigModalItem()}
        onSave={handleSalvarItem}
      />

      <ModalImportar
        idContrato={idContrato}
        visible={visibleModalImportar}
        onClosed={() => setVisibleModalImportar(false)}
        onUpdated={handleImportarUpdated}
      />

      <ModalHistoricoLogs
        isOpen={modalLog.isOpen}
        toggle={() => setModalLog(p => ({ ...p, isOpen: false }))}
        tipo={modalLog.tipo}
        idRegistro={modalLog.idRegistro}
        titulo={modalLog.titulo}
      />
    </div>
  )
}